<template>
  <div id="product-documents-rear-jacket-edit">

    <vs-alert color="danger" title="Rear Jacket Document Not Found" :active.sync="not_found">
      <span>Rear Jacket Document record with id: {{ id }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'rear-jacket.list'}" class="text-inherit underline">All
        Rear Jacket Documents</router-link>
      </span>
    </vs-alert>

    <rear-jacket-form v-if="model" v-model="model" ref="form" :forms="formReferences" :apiModel="apiModel"/>

    <div class="vx-row" v-if="model">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              :disabled="loading"
              @click="$router.push({ name: 'rear-jacket.list' })"
              class="ml-4 mt-2"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              :disabled="loading"
              @click="save"
              class="ml-auto mt-2"
              color="light"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import RearJacketForm from "@/views/pages/product-documents/rear-jacket/RearJacketForm";
import ProductDocumentEditMixin from "@/components/mixins/ProductDocumentEditMixin";

export default {
  name: "RearJacketEdit",
  components: {
    RearJacketForm
  },
  mixins: [ProductDocumentEditMixin],
  data() {
    return {
      apiModel: 'productRearJacket',
    };
  },
};
</script>

<style scoped>

</style>
